import { useNavigate } from 'react-router-dom';
import { projects } from '../data/projects';
import { ProjectCard } from '../components/ProjectCard';
import { Reveal } from '../components/Reveal';
import './Projects.css';

export function Projects() {
  const navigate = useNavigate();

  return (
    <section id="projects" className="projects-section">
      <Reveal className="section projects-head">
        <p className="eyebrow">{'// Selected work'}</p>
        <h2 className="section-title">
          Things I've <span className="grad">built</span>
        </h2>
        <p className="section-lead">
          A collection of products spanning mobile apps, AI systems, and robotics — from
          a launched startup to a robot that talks back.
        </p>
      </Reveal>

      <div className="projects-list">
        {projects.map((project, index) => (
          <ProjectCard
            key={project.id}
            project={project}
            index={index}
            onPrivacy={() => navigate('/habit-it/privacy')}
          />
        ))}
      </div>
    </section>
  );
}
